import { type JSX } from "react";
import {
  Grid,
  GridProps as MuiGridProps,
  Skeleton,
  SkeletonProps as MuiSkeletonProps,
} from "@mui/material";

import BaseCard, { BaseCardProps } from "../BaseCard/base-card";

type Props = {
  skeleton: SkeletonProps;
  gridItemProps?: GridProps;
  gridContainerProps?: GridProps;
} & Partial<Pick<BaseCardProps, "title" | "action">>;

const LoadingCard = (props: Props): JSX.Element => (
  <BaseCard
    data-testid="ds-loading-card"
    title={
      props.title !== undefined ? (
        props.title
      ) : (
        <Skeleton variant="rectangular" width={120} height={30} />
      )
    }
    action={
      props.action !== undefined ? (
        props.action
      ) : (
        <Skeleton variant="rectangular" width={50} height={30} />
      )
    }
  >
    <Grid container spacing={3} {...props.gridContainerProps}>
      {Array.from({ length: props.skeleton.count }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid key={i} {...props.gridItemProps}>
          <Skeleton variant="rectangular" {...props.skeleton.props} />
        </Grid>
      ))}
    </Grid>
  </BaseCard>
);

type GridProps = Omit<MuiGridProps, "container" | "item">;
type SkeletonProps = {
  count: number;
  props?: MuiSkeletonProps;
};

export { LoadingCard };
export type { SkeletonProps };
